<template>
    <form @submit="onSubmit" action="/account/reset-password" method="post" ref="form" class="space-y-8">
        <div class="space-y-6">
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="mt-1 relative rounded-md max-w-lg sm:max-w-xs">
                        <input type="hidden" name="_token" :value="csrf">
                        <input type="hidden" name="email" :value="email">
                        <input type="hidden" name="token" :value="token">
                        <text-input
                            label="Password"
                            :validation="v$.password"
                            name="password"
                            autocomplete="new-password"
                            type="password"
                            v-model="password"
                        ></text-input>
                    </div>
                </div>
                <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="mt-1 relative rounded-md max-w-lg sm:max-w-xs">
                        <text-input
                            label="Confirm Password"
                            name="password_confirmation"
                            :validation="v$.password_confirmation"
                            autocomplete="new-password"
                            type="password"
                            v-model="password_confirmation"
                        ></text-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-5">
            <div class="flex justify-start">
                <button
                    @click="submit"
                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-md tracking-wider font-medium rounded-md text-white bg-ap-primary hover:bg-ap-primary-darkened focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Reset
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {
    helpers,
    minLength,
    required,
    sameAs,
} from '@vuelidate/validators';
import TextInput from '../TextInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            password: null,
            password_confirmation: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            errors: {},
        };
    },
    validations() {
        return {
            password: {
                required: withMessage('New password is required', required),
                minLength: withMessage('Password must be at least 6 characters', minLength(6)),
            },
            password_confirmation: {
                sameAsPassword: withMessage('Passwords do not match', sameAs(this.password)),
            },
        };
    },
    props: {
        email: { required: true },
        token: { required: true },
    },
    methods: {
        async onSubmit(e) {
            const result = await this.v$.$validate();

            if (!result) {
                e.preventDefault();
                return false;
            }

            return true;
        },
    },
    components: {
        TextInput,
    },
};
</script>
